import React from 'react';
import './styles.scss';
import Table from 'react-bootstrap/Table';
import Formats from 'utils/formats';
import { Link } from 'react-router-dom';
import { CONTEXT } from 'utils/types';
import { EllipsisButton } from '@spins/react-ui-library';

interface Props {
  favorites: Array<Favorite>;
  onActionClick(id: string, name: string): void;
}

interface Filter {
  accounts: string[];
  items: string[];
  stores: string[];
  states: string[];
  weeks: number;
  endWeek: string;
}

interface Favorite {
  id: string;
  context: string;
  name: string;
  data: Filter;
  url: string;
  created: string;
  deleted: string;
}

const FavoritesTable: React.FC<Props> = ({ favorites, onActionClick }) => {
  const urlInfo = (url: string, type: string) => {
    let newUrl = new URL(url);
    return newUrl[type];
  };

  return (
    <Table className="favorites-table">
      <colgroup>
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th>Name</th>
          <th>Page</th>
          <th>Created</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {favorites &&
          favorites.length > 0 &&
          favorites
            .filter(fav => !fav.deleted && fav.context === CONTEXT && fav.url !== null)
            .map((fav, index) => {
              let linkTo = {
                pathname: urlInfo(fav.url, 'pathname'),
                search: urlInfo(fav.url, 'search'),
                state: { prevPath: 'favorites', ...fav.data }
              };
              return (
                <tr key={index}>
                  <td>{fav.name}</td>
                  <td>
                    <Link to={linkTo}>{fav.url}</Link>
                  </td>
                  <td>{Formats.date(fav.created)}</td>
                  <td>
                    <EllipsisButton
                      overlayPlacement="bottom-end"
                      options={[
                        { label: 'Delete', onClick: () => onActionClick(fav.id, fav.name) }
                      ]}
                    />
                  </td>
                </tr>
              );
            })}
      </tbody>
    </Table>
  );
};

export default FavoritesTable;
